import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

export default {

  init() {
    this.create();
  },

  create() {
    const closeSVGString = '<svg aria-hidden="true" class="pswp__icn" height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg"><path d="m5.41421356 4 9.58578644 9.5857864 9.5857864-9.5857864h1.4142136v1.41421356l-9.593 9.59278644 9.593 9.593v1.4142136h-1.4142136l-9.5857864-9.5857865-9.58578644 9.5857865h-1.41421356v-1.4142136l9.593-9.593-9.593-9.59278644v-1.41421356z" fill="#444444"/></svg>'
    const zoomSVGString = '<svg aria-hidden="true" class="pswp__icn" height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg"><path d="m22 13c0 2.12-.93 4.3-2.16 5.84 0 0 1.39 1.64 1.91 1.5.61-.16 6.1 5.36 6.1 5.36l-.77 1.04-.85.7s-6.14-5.18-5.99-5.86c.12-.54-1.32-1.76-1.32-1.76-1.54 1.23-3.8 2.17-5.92 2.17-4.97 0-9-4.03-9-9s4.03-8.99 9-8.99 9 4.03 9 9zm-16.83 0c0 4.32 3.51 7.83 7.83 7.83s7.83-3.51 7.83-7.83-3.51-7.83-7.83-7.83-7.83 3.51-7.83 7.83z"/><path  fill="currentColor" class="pswp__zoom-icn-bar-h" d="m8.34 12.5h9.32v1h-9.32z"/><path  fill="currentColor" class="pswp__zoom-icn-bar-v" d="m12.5 8.91h1v8.19h-1z"/></svg>';
    let videoPlayers = [];

    const lightbox = new PhotoSwipeLightbox({
      gallery: '#productSlider',
      children: 'a',
      showHideAnimationType: 'fade',
      bgOpacity: 0.6,
      wheelToZoom: true,
      tapAction: 'zoom-or-close',
      closeSVG: closeSVGString,
      zoomSVG: zoomSVGString,
      pswpModule: PhotoSwipe
    });

    // Parse items for video content
    lightbox.addFilter('itemData', (itemData, index) => {
      const videoUrl = itemData.element.dataset.pswpVideoUrl;
      if(videoUrl) {
        itemData.videoUrl = videoUrl;
      }
      return itemData;
    });

    // Initialize videos
    lightbox.on('contentLoad', (e) => {
      const { content } = e;
      if(content.type === 'video') {
        e.preventDefault();
        videoPlayers = [];

        content.element = document.createElement('div');
        content.element.className = 'pswp__video-container';

        const wrapper = document.createElement('div');
        wrapper.classList.add('pswp__video-inner');
        content.element.appendChild(wrapper);

        let player = new Vimeo.Player(wrapper, { url: content.data.videoUrl });
        videoPlayers.push(player);
      }
    });

    // Pause on change
    lightbox.on('change', () => {
      videoPlayers.forEach(function(elem, index) {
        elem.pause();
      });
    });

    // Initialize
    lightbox.init();
  }

};
